module.exports = __webpack_public_path__ + "img/kormanyvaltasig_nem_szulok_17.84dc0b40.jpg";